
    import {
        Vue,
        Component
    } from 'vue-property-decorator'

    import AddOrUpdate from './articles-add-or-update'
    import ShowInfo from './articles-info'
    import Template from "@/template.vue";
    @Component({
        name: 'aricles',
        components:{
            Template,
            AddOrUpdate,
            ShowInfo
        }
    })
    export default class aricles extends Vue {
        addOrUpdateVisible=false
        currentNo: number = 1;
        pageSize: number = 10;
        pageTotal: number = 0;
        dataList=[]
        categorys=[]
        showInfoVisible=false
        startTime=[]
        searchForm={
            title:'',
            author:'',
            startTimest:'',
            startTimeed:'',
            categoryId:'',
            isIndexScroll:''
        }
        loading: boolean = false;
        dataListSelections=[];
        customertypeList=[];
        previewDialogVisible: boolean =false;
        viewhtml=''
        created() {
          this.searchData();
          this.getCategory()
            this.getCustomerType()
        }

        handleSizeChange(val: number) {
            this.pageSize = val;
            this.getUserList();
        }
        handleCurrentChange(val: number) {
            this.currentNo = val;
            this.searchData();
        }
        showInfo(row){

            this.showInfoVisible = true
            this.$nextTick(() => {
                this.$refs.showInfo.init(row)
            })
        }
        showPreview(row){
            let that=this
            this.$http({
                url: '/bjba/article/info/'+row,
                method: 'get'
            }).then(({data}) => {
                console.log(data)
                that.viewhtml= data.data.content
                that.previewDialogVisible = true
            })
        }
        updateIndexScroll(id,status) {
            this.$confirm(`确定${status==0?'取消':'设为'}首页轮播?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http({
                    url: `/bjba//article/updateIndexScroll`,
                    method: 'post',
                    params: {id:id,status:status}
                }).then(({data}) => {
                    if (data && data.code === 200) {
                        this.$message
                        ({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500
                        })
                        this.searchData()
                    } else if(data && data.code ==500) {
                        this.$message
                        ({
                            message: data.message,
                            type: 'error',
                            duration: 1500
                        })
                    }
                })
            }).catch(() => {
            })
        }
        // 多选
        selectionChangeHandle (val) {
            this.dataListSelections = val
        }
        getCategory() {
            this.$http({
                url: '/bjba/category/queryAll',
                method: 'get'
            }).then(({data}) => {
                this.categorys = data.data
            })
        }
        addOrUpdate(val: any) {

            this.addOrUpdateVisible = true
            this.$nextTick
            (() => {
                this.$refs.addOrUpdate.init(val)
            })
        }
        deleteHandle (id) {
            let ids = id ? [id] : this.dataListSelections.map(item => {
                return item.id
            })
            if(!ids || ids.length==0) return
            this.$confirm
            (`确定进行[删除]操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http({
                    url: `/bjba//article/delete`,
                    method: 'post',
                    data: ids
                }).then(({data}) => {
                    if (data && data.code === 200) {
                        this.$message
                        ({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500
                        })
                        this.searchData()
                    } else if(data && data.code ==500) {
                        this.$message
                        ({
                            message: data.message,
                            type: 'error',
                            duration: 1500
                        })
                    }
                })
            }).catch(() => {
            })
        }
        changeIndex(){
            this.currentNo =1
        }
        searchData () {
            this.loading = true
            if(this.startTime &&this.startTime.length==2){
                this.searchForm.startTimest = this.startTime[0]
                this.searchForm.startTimeed = this.startTime[1]
            } else{
                this.searchForm.startTimest = ''
                this.searchForm.startTimeed = ''
            }
            this.searchForm.page = this.currentNo;
            this.searchForm.pagesize = this.pageSize
            this.$request
                    .get('/bjba/article/list',{params:this.searchForm})
                    .then(res => {
            const {data} = res
            this.loading = false
            this.dataList = data.data.content
                        console.log("data:",this.dataList)
            this.pageTotal = data.data.totalElements
            }).catch(err => {
            this.$message
            ({
            message: '获取列表出现异常!',
            type: 'error',
            center: true,
            showClose: true
            })
            this.loading = false
            console.log(err)
            })
        }
        getCustomerType() {
            let that = this;
            this.$request
                .get("/bjba/customertype/findAll")
                .then((res) => {
                    console.log("customertype",res.data.data)
                    that.customertypeList = res.data.data;
                });
        }
        getCustomerTypeForId(id){
            let that = this;
            var obj=that.customertypeList.find(function (x) {
                return x.id === id
            })
            return obj.name;
        }
        getCustomerTypeName(id){
            console.log(id)
            let that = this;
            let array=id.split(",");
            let typename="";
            for (let i = 0; i < array.length; i++) {
                let name=that.getCustomerTypeForId(array[i])
                typename=typename+name+","
            }
            return typename.substring(0,typename.length-1)
        }
    }
